import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { spacing, textColor } from '../../theming';
import { labelStyle } from './vinExtractionStyles';
import NoValue from './NoValue';
import AttemptConfidenceBar from './AttemptConfidenceBar';

const AttemptConfidence = ({ attempt, threshold, thresholdIsCurrent }) => {
    const { t } = useTranslation('vinExtraction');

    return (
        <Flex vertical gap={spacing[0.5]}>
            <Flex justify="space-between" align="baseline">
                <span style={labelStyle}>{t('drawer.attempt.confidence')}</span>
                {attempt.confidence === null ? (
                    <NoValue label={t('drawer.attempt.noConfidence')} />
                ) : (
                    <span
                        style={{
                            fontWeight: 600,
                            color: attempt.lowConfidence ? textColor.warning : textColor.primary,
                        }}
                    >
                        {attempt.confidence.toFixed(2)}
                    </span>
                )}
            </Flex>
            {attempt.confidence !== null && (
                <AttemptConfidenceBar attempt={attempt} threshold={threshold} thresholdIsCurrent={thresholdIsCurrent} />
            )}
        </Flex>
    );
};

export default AttemptConfidence;
